var _defs, _rect, _circle, _circle2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a78bfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b3d2e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 18,
    floodColor: "rgba(0,0,0,0.18)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 42,
    fill: "url(#g)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1030,
    cy: 120,
    r: 210,
    fill: "rgba(255,255,255,0.18)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 640,
    r: 260,
    fill: "rgba(255,255,255,0.12)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 120,
    width: 980,
    height: 520,
    rx: 32,
    fill: "rgba(255,255,255,0.75)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,160)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
    fontWeight: 900,
    fontSize: 54,
    fill: "#0e1a14"
  }, "Lavender Calm Candle"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 58,
    fontFamily: "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
    fontWeight: 700,
    fontSize: 22,
    fill: "rgba(14,26,20,0.66)"
  }, "Lavender \u2022 Chamomile \u2022 Musk"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,60)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 240,
    height: 240,
    rx: 36,
    fill: "rgba(11,61,46,0.10)",
    stroke: "rgba(11,61,46,0.15)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56,56)",
    fill: "rgba(11,61,46,0.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 170c50-10 90-40 120-95 10 65-25 140-80 160-30 12-52-5-40-65z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,170)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 520,
    height: 290,
    rx: 26,
    fill: "rgba(244,185,66,0.20)",
    stroke: "rgba(244,185,66,0.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 0,
    width: 380,
    height: 290,
    rx: 26,
    fill: "rgba(255,122,89,0.18)",
    stroke: "rgba(255,122,89,0.30)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 56,
    fontFamily: "ui-sans-serif, system-ui",
    fontWeight: 900,
    fontSize: 20,
    fill: "rgba(90,59,0,0.95)"
  }, "Seasonal blends"), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 92,
    fontFamily: "ui-sans-serif, system-ui",
    fontWeight: 700,
    fontSize: 16,
    fill: "rgba(90,59,0,0.70)"
  }, "Clean notes \u2022 Warm memories"), /*#__PURE__*/React.createElement("text", {
    x: 586,
    y: 56,
    fontFamily: "ui-sans-serif, system-ui",
    fontWeight: 900,
    fontSize: 20,
    fill: "rgba(90,32,18,0.95)"
  }, "Handcrafted"), /*#__PURE__*/React.createElement("text", {
    x: 586,
    y: 92,
    fontFamily: "ui-sans-serif, system-ui",
    fontWeight: 700,
    fontSize: 16,
    fill: "rgba(90,32,18,0.70)"
  }, "Small batch \u2022 Premium feel")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct4);
export default __webpack_public_path__ + "static/media/product-4.7748b42935cc7609be4da5115ab51411.svg";
export { ForwardRef as ReactComponent };